export var wrapEventListener = function wrapEventListener(target, eventListener) {
  if (typeof eventListener === 'function') {
    return function (event) {
      var descriptor = {
        value: target
      };
      Object.defineProperties(event, {
        currentTarget: descriptor,
        target: descriptor
      });
      return eventListener.call(target, event);
    };
  }

  return eventListener;
};